export default "__VITE_ASSET__DHFiQa04__"